
/* eslint-disable @typescript-eslint/no-shadow */
export namespace TypesSortOrder {
  export enum TypesSortOrder {
    ASCENDING = "ASCENDING",
    DESCENDING = "DESCENDING",
  }

  export interface TypesSortOrderDTO {
    case: string;
  }

  export const fromDTO = (dto: TypesSortOrderDTO): TypesSortOrder => {
    if (dto === undefined || dto === null) {
      throw new InvalidTypesSortOrderError(
        `Invalid DTO ${dto} provided for TypesSortOrder.TypesSortOrder`
      );
    }
    switch (dto.case) {
      case "ASCENDING":
        return TypesSortOrder.ASCENDING;
      case "DESCENDING":
        return TypesSortOrder.DESCENDING;
      default:
        throw new InvalidTypesSortOrderError(
          `Case ${dto.case} is not valid case of TypesSortOrder.TypesSortOrder`
        );
    }
  };

  export const toDTO = (typesSortOrder: TypesSortOrder): TypesSortOrderDTO => {
    const enumDTO = {
      case: TypesSortOrder[typesSortOrder],
    };
    return enumDTO;
  };
}

export class InvalidTypesSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTypesSortOrderError";
  }
}
export class InvalidTypesSortOrderAscendingError extends InvalidTypesSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTypesSortOrderAscendingError";
  }
}

export class InvalidTypesSortOrderDescendingError extends InvalidTypesSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidTypesSortOrderDescendingError";
  }
}
